import { render, staticRenderFns } from "./zoomer.vue?vue&type=template&id=1359d18a&scoped=true&"
import script from "./zoomer.vue?vue&type=script&lang=ts&"
export * from "./zoomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359d18a",
  null
  
)

export default component.exports